module.exports = __webpack_public_path__ + "ru.svg?ca0208a9feee19f3e9a8789d9ac2dec7";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ru.svg
// module id = 1366
// module chunks = 27